import { SearchParams } from '@/types'
import { HistoryType, WaterConsumptionType } from '@/types/simulation'
import type { WaterUsageResponse } from '@/types/waterUsage'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const historyLogApi = {
  getFlowHistory(payload: HistoryType) {
    const url = `/api/v2/historylog/flow-history`
    return axiosClient.post(url, payload)
  },
  getFlowProgram(payload: HistoryType) {
    const url = `/api/v2/historylog/program-history`
    return axiosClient.post(url, payload)
  },
  getWaterConsumption(payload: WaterConsumptionType) {
    const url = `/api/v2/historylog/water-consumption-historylog`
    return axiosClient.post(url, payload)
  },
  getTemplateHistory(payload: HistoryType) {
    const url = `/api/v2/historylog/exprot-history-log`
    return axiosClient.post(url, payload, {
      responseType: 'blob',
    })
  },
  getWaterUsage(searchParams: SearchParams) {
    const url = `/api/v2/historylog/water-usage`
    return axiosClient.get(url + queryStringify(searchParams))
  },
  getNextMonthTotalWaterUsage(interfaceId: number) {
    const url = `/api/historylog/next-month-total-water-usage?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },

  getMtdTotalWaterUsage(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/mtd-total-water-usage?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },
  getCostOfWater(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/mtd-cost-of-water?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },
  getEstWaterUsage(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/est-water-usage-next-month?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getFinancialWaterUsage(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/financial-ytd-water-usage?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getFinancialCostWater(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/financial-ytd-cost-of-water?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getAvgDailyRainFall(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/mtd-avg-daily-rain-fall?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getAvgTemperature(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/mtd-avg-daily-temperature?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getAvgDailyET(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/mtd-avg-daily-et?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getChartWaterUsage(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/chart-actual-total-water-usage?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get<{ data: WaterUsageResponse }>(url, {
      timeout: 300000
    })
  },

  getChartWaterUsageV2(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/chart-actual-total-water-usage?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get<WaterUsageResponse>(url, {
      timeout: 300000
    })
  },

  getChartMonthlyET(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/chart-monthly-et?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getChartWater(interfaceId: number, month: number, year: number) {
    const url = `/api/v2/monthlyreportcard/chart-water-usage?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },

  getChartWeatherInfo(interfaceId: number, month: number, year: number) {
    const url = `/api/monthlyreportcard/chart-weather-info?interfaceId=${interfaceId}&month=${month}&year=${year}`
    return axiosClient.get(url)
  },
}

export default historyLogApi
